import { render } from "./proCardImg.vue?vue&type=template&id=08474ac5&scoped=true"
import script from "./proCardImg.vue?vue&type=script&lang=js"
export * from "./proCardImg.vue?vue&type=script&lang=js"

import "./proCardImg.vue?vue&type=style&index=0&id=08474ac5&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08474ac5"]])

export default __exports__